module.exports = __webpack_public_path__ + "static/media/logo-footer.e6ad3c17.svg";